import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { API_PATH } from 'api/apiUtils';

const languages = ['et', 'en'];

const basePath = '/v1/translations';

const customPathDetector = {
  name: 'customPath',
  lookup({ possibleLanguages }) {
    let found;
    if (typeof window !== 'undefined') {
      found = possibleLanguages.find(pattern =>
        window.location.pathname.match(new RegExp(`/(${pattern})/?`))
      );
    }
    return found;
  },
  cacheUserLanguage() {},
};

const createLanguageBackendPath = function() {
  return {
    loadPath: API_PATH + `${basePath}?language={{lng}}`, //'locales/{{lng}}/{{ns}}.json',
    parse: function(data) {
      return {
        ...JSON.parse(data),
      };
    },
  };
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(customPathDetector);

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(languageDetector)
  .init({
    backend: createLanguageBackendPath(),
    fallbackLng: languages[0],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    keySeparator: false,
    whitelist: languages,
    detection: {
      order: ['customPath', 'localstorage'],
      checkWhitelist: true,
      possibleLanguages: languages,
    },
  });

i18n.on('languageChanged', lng => {
  const { location, history } = window;
  const { pathname, search } = location;
  const languageString = languages.find(pattern =>
    pathname.match(new RegExp(`/(${pattern})/?`))
  );
  if (!languageString) {
    window.location.pathname = `${process.env.PUBLIC_URL}/${lng}`;
  } else {
    const replacementPath = pathname.slice(process.env.PUBLIC_URL.length + 3);
    history.pushState(
      null,
      '',
      `${process.env.PUBLIC_URL}/${lng}${replacementPath}${search}`
    );
  }
});

export default i18n;
